import { CurrentUser } from "../types/user";

// Standalone routes (outside FeedLayout) render their own <Header/> but the
// auth modal / create-content modal / digest subscription state all live on
// AppContent. AppContent listens for these window events (see App.tsx) so
// any page can trigger them without prop-drilling through the router tree.
export function dispatchAppEvent(name: string, detail?: unknown): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function getStoredCurrentUser(): CurrentUser | null {
  if (typeof window === "undefined") return null;
  try {
    const stored = localStorage.getItem("inspirelens_user");
    return stored ? (JSON.parse(stored) as CurrentUser) : null;
  } catch {
    return null;
  }
}
